import { SylaApiError } from "@syla/shared/errors/SylaApiError";
import axios from "axios";

/**
 * Map an axios error response to a standard {@link SylaApiError} or fallback to
 * rethrow the error.
 */
export function throwSylaApiError(error: unknown): never {
  if (axios.isAxiosError(error)) {
    const problem = error.response?.data;
    if (SylaApiError.isProblem(problem)) {
      throw new SylaApiError(problem.code, problem);
    }
  }

  // sometimes the response data has already been parsed out.
  else if (SylaApiError.isProblem(error)) {
    throw new SylaApiError(error.code, error);
  }

  throw error;
}

export async function parseProblemFromBlob(error: unknown) {
  // if response is a blob then it's not JSON, so we need to parse it.
  if (axios.isAxiosError(error) && error.response?.data instanceof Blob) {
    return JSON.parse(await error.response.data.text());
  }
  return error;
}
